module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-box"
  }, [_c('header', [_c('div', {
    staticClass: "search flex-1"
  }, [_c('form', {
    attrs: {
      "action": "#"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSearch($event)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-sousuo_sousuo"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "ipt",
    staticClass: "flex-1",
    attrs: {
      "type": "text",
      "placeholder": "请输入商品名"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchText.length > 0),
      expression: "searchText.length>0"
    }],
    staticClass: "iconfont icon-cuowu",
    on: {
      "click": function($event) {
        _vm.searchText = ''
      }
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa413c3a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Head.vue
// module id = 608
// module chunks = 0